import * as React from "react";

import { Grid, makeStyles, Tab, Tabs, Typography } from "@material-ui/core";
import clsx from "clsx";
import uuid from "react-uuid";

const useStyles = makeStyles((theme) => ({
  PublicTabs: {},
  tab: {
    marginBottom: 10,
    cursor: "pointer",
    padding: 10,
  },
  activeTab: {
    backgroundColor: "#E4ECFF",
  },
  text: {
    color: "#292929",
    fontSize: 16,
    fontWeight: "bold",
  },
  activeText: {
    color: "#0A369D",
  },
}));
const NewPublicSlidingTabs = ({
  data,
  tab,
  setTab,
  handleTabChange,
  customClassName,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      className={clsx(classes.PublicTabs, customClassName && customClassName)}
    >
      {data.map((item, i) => (
        <Grid
          item
          xs={12}
          className={clsx(classes.tab, i === tab ? classes.activeTab : "")}
          onClick={(e) => handleTabChange(e, i)}
        >
          <Typography
            variant="h5"
            className={clsx(classes.text, i === tab ? classes.activeText : "")}
          >
            {item}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default NewPublicSlidingTabs;
